import script from "./uploadYpjy.vue?vue&type=script&setup=true&lang=ts"
export * from "./uploadYpjy.vue?vue&type=script&setup=true&lang=ts"

import "./uploadYpjy.vue?vue&type=style&index=0&id=1d4404db&lang=scss"
import "./uploadYpjy.vue?vue&type=style&index=1&id=1d4404db&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d4404db"]])

export default __exports__